var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 112.57,
    cy: 108.41,
    r: 49.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.93,
    y: 191.7,
    width: 83.29,
    height: 249.87,
    rx: 1.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M437.4,283.32V424.91a16.71,16.71,0,0,1-16.66,16.66h-50a16.71,16.71,0,0,1-16.66-16.66V308.3a41.65,41.65,0,0,0-83.29,0V424.91a16.71,16.71,0,0,1-16.66,16.66h-50a16.71,16.71,0,0,1-16.66-16.66V208.36a16.71,16.71,0,0,1,16.66-16.66h50a16.7,16.7,0,0,1,16.66,16.66V219c16.66-21.58,44.23-35.65,75-35.65C391.76,183.37,437.4,216.68,437.4,283.32Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.de0cf8233a42f9ded8154397b3587528.svg";
export { ForwardRef as ReactComponent };